import { Container, Group, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png'; // Adjust the path as necessary
import classes from './HeaderMenu.module.css';

export function HeaderMenu() {
    return (
        <Container size="100%" h={60} px="xl">
            <Group justify="space-between" h="100%">
                <Group>
                    <Group gap={8} className={classes.logoGroup}>
                        <img src={logo} alt="TuboTubo Logo" style={{ height: 47, width: 47 }} />
                        <Anchor
                            component={Link}
                            to="/"
                            className={classes.logoText}
                        >
                            TuboTubo
                        </Anchor>
                    </Group>
                    <Anchor
                        component={Link}
                        to="/daily-peaks"
                        className={classes.recordLink}
                        underline="never"
                    >
                        Record 24h
                    </Anchor>
                </Group>
                <Group>
                    <Anchor
                        component={Link}
                        to="/privacy"
                        className={classes.privacyLink}
                        underline="never"
                    >
                        Privacy Policy
                    </Anchor>
                </Group>
            </Group>
        </Container>
    );

}